var _path, _path2;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3417 2H3.64013C3.20514 2 2.78797 2.1728 2.48038 2.48038C2.1728 2.78797 2 3.20514 2 3.64013V10.3406C1.9999 10.556 2.04224 10.7694 2.1246 10.9684C2.20697 11.1675 2.32773 11.3484 2.48001 11.5007L12.4968 21.5197C12.6909 21.7138 12.9305 21.856 13.1938 21.9334C13.457 22.0108 13.7355 22.0209 14.0037 21.9628C14.2719 21.9047 14.5212 21.7803 14.7288 21.6008C14.9365 21.4214 15.0958 21.1928 15.1921 20.9359L16.7612 16.7612L20.937 15.1943C21.1939 15.0979 21.4225 14.9386 21.6019 14.731C21.7814 14.5234 21.9058 14.2741 21.9639 14.0059C22.022 13.7377 22.0119 13.4592 21.9345 13.196C21.8571 12.9327 21.7149 12.6931 21.5208 12.499L11.5007 2.48001C11.1933 2.17274 10.7764 2.00009 10.3417 2Z",
    stroke: "#878E95",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.92078 6.51074C6.83968 6.51074 6.7604 6.53479 6.69297 6.57985C6.62554 6.6249 6.57299 6.68894 6.54195 6.76386C6.51092 6.83879 6.5028 6.92123 6.51862 7.00077C6.53444 7.08031 6.57349 7.15337 6.63084 7.21071C6.68818 7.26806 6.76124 7.30711 6.84078 7.32293C6.92032 7.33875 7.00276 7.33063 7.07769 7.2996C7.15261 7.26856 7.21665 7.21601 7.2617 7.14858C7.30676 7.08115 7.33081 7.00187 7.33081 6.92078C7.33095 6.86689 7.32044 6.81351 7.29989 6.76369C7.27933 6.71388 7.24914 6.66862 7.21103 6.63052C7.17293 6.59241 7.12767 6.56222 7.07786 6.54166C7.02805 6.52111 6.97466 6.5106 6.92078 6.51074",
    stroke: "#878E95",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTag);
export default __webpack_public_path__ + "static/media/tag.7aab000c.svg";
export { ForwardRef as ReactComponent };